<table class="table table-sm">
  <thead>
    <tr>
      <th scope="col">
        <button type="button" class="btn btn-primary btn-sm" (click)="refresh()">refresh</button>
      </th>
      @for (col of getColumns(); track col) {
        <th scope="col">{{col}}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (module of getRows(); track module) {
      <tr>
        <th scope="row">{{module}}</th>
        @for (stage of getColumns(); track stage) {
          <td class="keepNewlines">{{getVersion(stage, module)}}<br/>{{getGitCommit(stage, module)}}</td>
        }
      </tr>
    }
  </tbody>
</table>
